<template>
    <div>
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label></label>
                </div>
                <div class="form-value">
                    <span>操作成功！</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    //
    export default {
        name: 'swb-ready-adjust-asset-confirm',
        desc: '待调整资产调整完确认框',
        data: function () {
            return {
            }
        },
        created: function () {
        },
        mounted() {
        },
        destroyed() {
        },
        methods: {
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/assetFiscal/ReadyAdjustAssetConfirm.vue